var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSegundaViaCartaoIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;}.d{fill:#5a5a5a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(5 5)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H20V20H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M16.667,3.333H3.333A1.654,1.654,0,0,0,1.675,5L1.667,15a1.661,1.661,0,0,0,1.667,1.667H16.667A1.661,1.661,0,0,0,18.333,15V5A1.661,1.661,0,0,0,16.667,3.333Zm0,11.667H3.333V10H16.667Zm0-8.333H3.333V5H16.667Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSegundaViaCartaoIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/segundaViaCartaoIcon.53ae05d4.svg";
export { ForwardRef as ReactComponent };